import { alpha } from "@mui/material/styles";

const getTabBackground = (theme) =>
  theme.palette.mode === "dark" ? "background.elevated" : "background.paper";

export const styles = {
  root: {
    width: "95%",
    display: "flex",
    justifyContent: "center",
    alignItems: "stretch",
    flexDirection: "column",
  },
  tabsRow: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-end",
    position: "relative",
  },
  line: {
    width: "100%",
    borderBottom: "2px solid",
    borderBottomColor: "secondary.main",
    position: "absolute",
    left: 0,
    bottom: 0,
  },
  MNTabsStyle: {
    width: "fit-content",
    minHeight: "40px",
    overflowX: "auto",
    whiteSpace: "nowrap",
    zIndex: 2,
    backgroundColor: "transparent",
    "& .MuiTabs-indicator": {
      display: "none",
    },
    "& .MuiTabs-flexContainer": {
      gap: "0.5rem",
      alignItems: "flex-end",
    },
  },
  MNTabStyle: (isSelected) => ({
    borderRadius: "4px 4px 0 0",
    transition: "all 0.3s ease-in-out",
    height: "3rem",
    px: "0.5rem",
    py: isSelected ? "0.75rem" : "0.5rem",
    fontWeight: isSelected ? "bold" : "500",
    backgroundColor: (theme) => getTabBackground(theme),
    color: isSelected ? "secondary.main" : "primary.main",
    border: "2px solid",
    borderColor: isSelected ? "secondary.main" : "primary.main",
    borderBottomColor: (theme) =>
      isSelected
        ? getTabBackground(theme)
        : alpha(theme.palette.secondary.main, 1),
    "&:hover": {
      opacity: 1,
    },
    "&.Mui-selected": {
      color: "secondary.main",
    },
  }),
};
